<template>
    <div>
      <search-result-header
        :keyword="params.keyword"
        active-tab="suppliers"
        :show-tabs="false"
        @search="searchCurrentPage"
        @switch-tab="switchResultTab"
      />
      <common-store-list ref="storeList" :keyword="params.keyword" :only-with-goods="true" />
    </div>
</template>

<script>
import CommonStoreList from '../common/CommonStoreList'
import SearchResultHeader from '../common/SearchResultHeader'
export default {
  name: 'HomeStorelist',
  components: {
    CommonStoreList,
    SearchResultHeader
  },
  data () {
    return {
      params: {
        keyword: this.$route.query.keywords ? this.$route.query.keywords : ''
      }

    }
  },

  watch: {
    '$route.query.keywords' (value) {
      this.params.keyword = value || ''
    }
  },

  methods: {
    searchCurrentPage (keyword) {
      if ((this.$route.query.keywords || '') === keyword) return
      this.params.keyword = keyword.trim()
      let query = Object.assign({}, this.$route.query)
      if (this.params.keyword) {
        query.keywords = this.params.keyword
      } else {
        delete query.keywords
      }
      this.$router.replace({ name: 'HomeStorelist', query: query })
    },
    switchResultTab (tab, keyword) {
      if (tab === 'products') {
        this.$router.push({ name: 'HomeGoodslist', query: keyword ? { keywords: keyword } : {} })
      } else {
        this.searchCurrentPage(keyword)
      }
    }
  }

}
</script>

<style scoped lang="scss">
</style>
